// extracted by mini-css-extract-plugin
export default {"dot-spinner":"DotSpinner_dot-spinner__IdXaT","dot":"DotSpinner_dot__loLNM","pulse":"DotSpinner_pulse__KFtsl"};